import { useEffect, useState } from "react";
import { LogOut } from "lucide-react";
import api from "@/api";

const CustomerAuth = () => {
  const [customer, setCustomer] = useState(undefined);

  useEffect(() => {
    // AuthCallback handles the session exchange when returning from Google
    if (window.location.hash?.includes("session_id=")) return;
    api.get("/auth/google/me")
      .then((r) => setCustomer(r.data))
      .catch(() => setCustomer(null));
  }, []);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const signOut = async () => {
    await api.post("/auth/google/logout").catch(() => {});
    setCustomer(null);
  };

  if (customer === undefined) return null;

  if (!customer) {
    return (
      <button
        onClick={signIn}
        data-testid="google-signin-btn"
        className="rounded-full px-5 py-2.5 font-mono text-xs uppercase tracking-[0.2em] border border-terracotta text-terracotta hover:bg-terracotta hover:text-cream transition-colors"
      >
        Sign In
      </button>
    );
  }

  return (
    <div className="flex items-center gap-3" data-testid="customer-profile">
      {customer.picture ? (
        <img
          src={customer.picture}
          alt={customer.name}
          title={customer.name}
          referrerPolicy="no-referrer"
          className="w-9 h-9 rounded-full border-2 border-terracotta object-cover"
        />
      ) : (
        <span className="w-9 h-9 rounded-full bg-terracotta text-cream flex items-center justify-center font-mono text-sm uppercase">
          {customer.name?.[0] || "C"}
        </span>
      )}
      <button
        onClick={signOut}
        data-testid="google-signout-btn"
        title="Sign out"
        aria-label="Sign out"
        className="text-charcoal/60 hover:text-terracotta transition-colors"
      >
        <LogOut size={16} />
      </button>
    </div>
  );
};

export default CustomerAuth;
